import { render, staticRenderFns } from "./InputURLButton.vue?vue&type=template&id=396ffad2&"
import script from "./InputURLButton.vue?vue&type=script&lang=js&"
export * from "./InputURLButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports